import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { ProductService } from 'src/app/services/product.service';
import { BaseAddComponent } from '../base-add/base-add.component';
import { Product } from 'src/app/entities/product';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRelatedComponent } from '../base-related/base-related.component';
import { ProductRelated } from 'src/app/entities/product-related';
import { ProductRelatedService } from 'src/app/services/product-related.service';
import { MIATableModel } from '@mobileia/core';

@Component({
  selector: 'app-product-related',
  templateUrl: './product-related.component.html',
  styleUrls: ['./product-related.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ProductRelatedComponent extends BaseRelatedComponent<ProductRelated> implements OnInit {

  displayedColumns = ['id', 'product', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    }
  ];
  pathUrlList = 'product';
  nameFieldParent = 'product_id';
  products = new Array<Product>();

  constructor(
    protected relatedService: ProductRelatedService,
    protected productService: ProductService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = relatedService;
    this.serviceParent = productService;
    this.newItem = new ProductRelated();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadProducts();
  }

  initFields() {
    this.configFields = [
      {
        type: 'select',
        key: 'related_id',
        title: 'Producto',
        caption: '',
        options: []
      },
    ];
  }

  processProducts() {
    let options = [];
    for (const parent of this.products) {
      options.push({
        title: parent.title,
        value: parent.id
      });
    }
    this.configFields[0].options = options;
  }

  loadProducts() {
    let params = new MIATableModel();
    params.itemPerPage = 300;
    this.productService.fetchList(params).toPromise().then(data => {
      if (!data.success) {
        return;
      }
      this.products = data.response.data;
      this.processProducts();
    });
  }

  itemLoaded() {
    this.newItem.product_id = this.item.id;
  }
}